function createFrozenWithGetters(obj: any) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        result[key] = {
            value,
            getKey: () => key
        };
    }
    return Object.freeze(result);
}
export default createFrozenWithGetters({
    REQUEST_TERMINATED: "EVFE002",
    REQUEST_TAMPERED: "EVFE001",
    CARDINFO_NO_COUNTRY: "EVFE003",
    OLD_SKU_MISMATCH: "EVFE004",
    SERVICE_VERIFICAION_FAILED: "EVFE005",
    MISSING_MANDATORY_INFO: "EVFE006",
    EXPIRED_CARD: "eV1385",
    DOWNGRADE_ALREADY_SCHEDULED: "EVFE008",
    SERVICE_INFO_NOT_FOUND: "EVFE007",
    ADDON_NOT_ALLOWED_COMBINED: "EVFE012",
    ADDON_NOT_ALLOWED: "EVFE013",
})